export default function ContactInfoIcon({
  width = 22,
  height = 15,
  color = "#8E8C8F",
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
    >
      <path
        d="M2.74996 2.00002H19.25V13H2.74996V2.00002ZM1.83329 0.166687C1.32704 0.166687 0.916626 0.577097 0.916626 1.08335V13.9167C0.916626 14.423 1.32704 14.8334 1.83329 14.8334H20.1666C20.6729 14.8334 21.0833 14.423 21.0833 13.9167V1.08335C21.0833 0.577097 20.6729 0.166687 20.1666 0.166687H1.83329ZM11.9166 3.83335H17.4166V5.66669H11.9166V3.83335ZM16.5 7.50002H11.9166V9.33335H16.5V7.50002ZM9.62496 5.66669C9.62496 6.93233 8.59894 7.95835 7.33329 7.95835C6.06764 7.95835 5.04163 6.93233 5.04163 5.66669C5.04163 4.40104 6.06764 3.37502 7.33329 3.37502C8.59894 3.37502 9.62496 4.40104 9.62496 5.66669ZM7.33329 8.87502C5.56138 8.87502 4.12496 10.3114 4.12496 12.0834H10.5416C10.5416 10.3114 9.10521 8.87502 7.33329 8.87502Z"
        fill={color}
      />
    </svg>
  );
}
